import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Zap } from "lucide-react";
import { SITE } from "../lib/site";

const links = [
  { to: "/", label: "Home", testId: "nav-home" },
  { to: "/services", label: "Services", testId: "nav-services" },
  { to: "/portfolio", label: "Portfolio", testId: "nav-portfolio" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 bg-white border-b border-hairline"
    >
      <div className="container-pro flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-3 group"
        >
          <span className="inline-flex h-9 w-9 items-center justify-center bg-navy text-white">
            <Zap className="h-4 w-4" strokeWidth={2.5} />
          </span>
          <span className="leading-tight">
            <span className="block font-heading font-black text-navy tracking-tight text-sm md:text-base">
              FIBER DRAFT
            </span>
            <span className="hidden md:block text-[10px] font-mono uppercase tracking-[0.2em] text-slateblue">
              NYCT / MTA Electrical
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testId}
              className={({ isActive }) =>
                `font-heading text-xs uppercase tracking-[0.18em] font-semibold transition-colors ${
                  isActive ? "text-navy" : "text-slateblue hover:text-navy"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="header-cta"
            className="btn-primary !py-2.5 !px-4 !text-xs"
          >
            Request a Quote
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden inline-flex items-center justify-center h-10 w-10 border border-hairline text-navy"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-hairline bg-white">
          <div className="container-pro py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`${l.testId}-mobile`}
                className={({ isActive }) =>
                  `py-3 font-heading text-sm uppercase tracking-[0.15em] font-semibold ${
                    isActive ? "text-navy" : "text-slateblue"
                  }`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="header-cta-mobile"
              className="btn-primary mt-2 w-full"
            >
              Request a Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
